<!----添加数据列表------>
<template>
  <div class="list-operation">
    <el-table
      class="list-operation-table"
      ref="multipleTable"
      v-loading="loading"
      :data="tableData"
      :max-height="tableOptions.height?tableOptions.height:maxHeight"
      header-row-class-name="table-header"
      @selection-change="selectRowChange"
    >
      <!--多选-->
      <el-table-column
        v-if="tableOptions.showSelect"
        type="selection"
        width="55"
        :selectable="selectEnable"
      ></el-table-column>
      <template v-for="(column,index) in (tableOptions && tableOptions.columns)">
        <el-table-column
          v-if="column.isShow===false?false:true"
          show-overflow-tooltip
          :prop="column.prop"
          align="center"
          :key="index"
          :label="column.label"
          :min-width="column.width || tableOptions.width"
        >

          <template slot-scope="scope">
            <div v-show="scope.$index < tableData.length-1">
              <span v-if="column.type =='index'">{{ scope.$index + 1 }}</span>
              <!--调价差额   = （现成本价-原成本价）* 库存数量 -->
              <el-input
                v-else-if="column.type == 'selfData'"
                v-model.trim="scope.row[column.prop]"
                disabled
              ></el-input>
              <span v-else-if="column.type =='operation' && !tableOptions.disabled">
                <span
                  v-if="!column.showDeleteOne"
                  @click="addFun(scope)"
                  class="icon"
                ><i class="icon el-icon-plus"></i></span>
                <span
                  v-if="!column.showDeleteOne"
                  @click="delFun(scope)"
                  class="icon"
                  style="margin-left: 5px"
                ><i class="icon el-icon-minus"></i></span>
                <span
                  v-if="column.showDeleteOne"
                  @click="delFun(scope)"
                  style="cursor: pointer;color:#409EFF"
                >删除</span>
              </span>
              <!--              <el-input-->
              <!--                v-else-if="column.type == columnType.input"-->
              <!--                @input="valueChange(column,scope.row,scope.$index)"-->
              <!--                v-model="scope.row[column.prop]"-->
              <!--                :disabled="tableOptions.disabled"-->
              <!--                @keyup.enter.native="searchKeyup(column,scope.row,scope.$index)"-->
              <!--                @blur="(column,scope.row,scope.$index)"-->
              <!--              ></el-input>-->
              <el-input
                v-else-if="column.type == columnType.input"
                v-model.trim="scope.row[column.prop]"
                :disabled="column.disabled || tableOptions.disabled"
                :maxLength="column.maxLength"
                @change="valueChange(column,scope.row,scope.$index)"
              ></el-input>
              <el-input-number
                v-else-if="column.type == columnType.inputNumber"
                @change="valueChange(column,scope.row,scope.$index)"
                :precision="column.precision||null"
                v-model.trim="scope.row[column.prop]"
                :min='column.min || 0'
                :disabled="column.disabled || tableOptions.disabled"
              ></el-input-number>
              <!--日期选择器-->
              <el-date-picker
                v-else-if="column.type === columnType.datePicker"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                v-model="scope.row[column.prop]"
                type="date"
                placeholder="选择日期"
                :disabled="tableOptions.disabled"
              ></el-date-picker>
              <!--日期时间选择器-->
              <el-date-picker
                :disabled="tableOptions.disabled"
                v-else-if="column.type === columnType.dateTimePicker"
                type="datetime"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                v-model="scope.row[column.prop]"
                placeholder="选择日期时间"
              ></el-date-picker>

              <!--开关-->
              <el-switch
                v-else-if="column.type === columnType.switch"
                v-model="scope.row[column.prop]"
                @change="valueChange(column,scope.row,scope.$index)"
              ></el-switch>
              <div
                v-else-if="column.enumData"
                v-html="$utils.getEnumItem(column,scope.row[column.prop])"
              ></div>
              <span
                v-else-if="column.deal"
                v-html="column.deal(scope.row,column)"
              ></span>
              <span
                @click="column.callback(scope.row,column)"
                v-else-if="column.callback"
                class="td-click"
                :title="column.title"
              >{{ scope.row[column.prop] }}</span>
              <span v-else>{{ scope.row[column.prop] }}</span>
              <span
                v-if="column.type=='more'&& !tableOptions.disabled"
                @click="moreFun(column,scope.row,scope.$index)"
                class="icon"
              >
                <i class="icon el-icon-more"></i></span>
            </div>
            <div v-show="scope.$index == tableData.length-1">
              {{ scope.row[column.prop] }}
            </div>
          </template>
        </el-table-column>
      </template>
    </el-table>
    <div class="pagination-box">
      <div class="fl total-cue">所有记录</div>
      <div class="fl total-cue">{{ page.total }}条</div>
      <!--分页-->
      <el-pagination
        class="tr"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page.current"
        :page-size="page.pageSize"
        :page-sizes="tableOptions.pageList || [10, 15, 20, 30, 40,100,200]"
        :layout="tableOptions.layout || 'sizes, prev, pager, next, jumper'"
        :total="page.total"
      ></el-pagination>
    </div>
  </div>
</template>
<script>
import Template from "../../page/system/wechat/Template.vue";
import api from '@/config/api';

export default {
  components: {Template},
  props: ["tableOptions"],
  data() {
    return {
      page: {
        current: 1,
        total: 0,
        pageSize: 10,
      },
      loading: false,
      oldDateTime: '',
      maxHeight: document.documentElement.clientHeight - 180 - 200,
      columnType: this.$utils.columnType,
      tableData: [],
      tableRow: {},
      selectRows: [],
      nowSearchParam: {},
    };
  },
  beforeCreate() {

  },
  mounted() {
    this.initData();
  },
  methods: {
    // 设置条数
    handleSizeChange(pageSize) {
      this.$utils.setDataByKey(this.$utils.localStorageKeys.pageSize, pageSize);
      this.page.pageSize = pageSize;
      this.page.current = 1;
      this.getTableData();
    },
    // 翻页
    handleCurrentChange(value) {
      this.page.current = value;
      this.getTableData();
    },
    //多选禁用与否
    selectEnable(row, rowIndex) {
      if (row.idx === '合计' || row.idx === '') {
        return false;
      } else {
        return true;
      }
    },
    selectRowChange(selectRows) {
      this.selectRows = selectRows;
      this.$emit("selectRowChange", selectRows);
    },
    selectAll() {
      for (let i = 0; i < this.tableData.length - 1; i++) {
        this.$refs.multipleTable.toggleRowSelection(this.tableData[i], true);
      }
    },
    toggleSelection() {
      this.tableData.forEach((item, idx) => {
        this.$nextTick(() => {
          if (item.selectStatus === 1) {
            console.log('toggleRowSelection');
            this.$refs.multipleTable.toggleRowSelection(this.tableData[idx], true);
          }
        });
      });
    },
    initData() {
      this.tableOptions.columns.map((column) => {
        if (column.prop) this.tableRow[column.prop] = "";
        if (column.type == "inputNumber")
          this.tableRow[column.prop] = undefined;
      });
      this.$set(this.tableData, 0, this.$utils.deepClone(this.tableRow));
      // if(!this.tableOptions.showSum){
      this.$set(this.tableData, 1, this.getSummaries(this.tableData));
      // }
    },
    valueChange(column, row, index) {
      if (column.change) {
        column.change(row, index);
      } else if (column.blur) {
        column.blur(row, index);
      } else {
        this.setCountData(row, index);
      }
    },
    // 失焦事件
    valueBlur(column, row, index) {
      column.blur && column.blur(row, index);
    },
    // 回车事件
    searchKeyup(column, row, index) {
      column.keyup && column.keyup(row, index)
    },
    //合计
    getSummaries(data) {
      let sums = {};
      if (!this.tableOptions.hideSum) { // 判断是否显示合计
        this.tableOptions.columns.map((column, index) => {
          if (index == 0) {
            sums[column.prop] = "合计";
          } else if (
            this.tableOptions.summaryColumns &&
            this.tableOptions.summaryColumns.filter((item) => {
              return item == column.prop;
            }).length > 0
          ) {
            if (data.length == 0) {
              sums[column.prop] = 0;
            } else {
              sums[column.prop] = data
                .map((item) => {
                  return parseFloat(item[column.prop] || 0);
                })
                .reduce(function (prev, cur, index, array) {
                  return prev + cur;
                });
            }
          } else {
            sums[column.prop] = "";
          }
        });
        let keys = Object.keys(sums);
        for (let i = 0; i < keys.length; i++) {
          if (typeof (sums[keys[i]]) == "number")
            sums[keys[i]] = this.$utils.returnFloat(sums[keys[i]]);
        }
      }
      return sums;

    },
    //删除行
    delFun(scope) {
      // if (this.oldDateTime) {
      //   let nowDateTime = new Date();
      //   if (nowDateTime - this.oldDateTime < 500) {
      //     alert('操作过于频繁');
      //     return false;
      //   }
      if (this.tableData.length === 2) return;
      let row = scope.row;
      if (row['weBlitemGoodsMapId']) {
        this.loading = true;
        this.$axios.fetchDelete(api.warehouse.weBlitemGoodsMap + '?id=' + row['weBlitemGoodsMapId']).then(data => {
          if (data.code === 200) {
            this.tableData.splice(scope.$index, 1);
            this.tableData.splice(this.tableData.length - 1, 1);
            this.tableData.push(this.getSummaries(this.tableData));
          }
        }).finally(() => {
          this.loading = false;
        });
      }
      // }
      // this.oldDateTime = new Date();
    },
    //添加行
    addFun() {
      this.tableData.splice(this.tableData.length - 1, 1);
      this.tableData.push(this.$utils.deepClone(this.tableRow));
      this.tableData.push(this.getSummaries(this.tableData));
    },
    //点击三个点事件
    moreFun(column, row, index) {
      column.callback && column.callback(row, index);
    },
    //为当前行赋值
    setColumnData(rowData, index) {
      const data = this.vertifyData(rowData);
      if (data.flag) {
        this.$message({
          message: "商品'" + data.goodsName + "'已存在",
          type: "warning",
        });
        for (let i = 0; i < this.tableData.length; i++) {
          if (this.tableData[i].idx == "") {
            this.tableData.splice(i, 1);
          }
        }
        return false;
      }
      //删除最后合并数据
      this.tableData.splice(this.tableData.length - 1, 1);
      rowData = {...rowData, ...this.rowData};
      this.$set(this.tableData, index, rowData);
      // console.log(Object.keys(rowData).length)
      if (Object.keys(rowData).length > 0) {
        for (let key in rowData) {
          this.tableOptions.columns.forEach(column => {
            //设置默认值
            if (column.defaultValue != undefined && !this.dataNotNull(rowData[column.prop])) {
              if (key === column.prop) {
                rowData[column.prop] = column.defaultValue;
              }
            }
            if (column.defaultChange) {
              column.defaultChange(rowData, index);
            }
          })
        }
      }
      this.$set(
        this.tableData,
        this.tableData.length,
        this.getSummaries(this.tableData)
      );
      return true;
    },
    setCountData(rowData, index) {
      this.tableData.splice(this.tableData.length - 1, 1);
      rowData = {...rowData, ...this.rowData};
      this.$set(this.tableData, index, rowData);
      this.$set(
        this.tableData,
        this.tableData.length,
        this.getSummaries(this.tableData)
      );
    },
    dataNotNull(data) {
      return data !== null && data !== undefined && data !== "";
    },
    //为列表赋值
    addMoreRow(rows, index) {
      // this.tableData.splice(this.tableData.length - 1, 1);
      this.tableData = this.tableData.filter(item => item.barCode);
      rows.map((row, idx) => {
        row = {...row, ...this.rowData};
        this.$set(this.tableData, index + idx, row);
      });
      let arr = this.tableData;
      this.tableData = [];
      // const res = new Map();
      // arr = arr.filter((a) => !res.has(a.id) && res.set(a.id, 1));//对于多规格不适用
      // arr = arr.filter((a) => !res.has(a.barCode) && res.set(a.barCode, 1));//过滤数组中重复的barCode
      arr.forEach((item, idx) => {
        this.tableOptions.columns.forEach(column => {
          //设置默认值
          if (column.defaultValue != undefined && !this.dataNotNull(item[column.prop])) {
            item[column.prop] = column.defaultValue;
          }
          if (column.defaultChange) {
            column.defaultChange(item, idx);
          }
        })
        this.$set(this.tableData, idx, item);
      });

      this.$set(
        this.tableData,
        this.tableData.length,
        this.getSummaries(this.tableData)
      );
    },
    vertifyData(rowData) {
      let data = {flag: false, goodsName: "", goodsId: ""};
      if (rowData.constructor === Array) {
        let goodsNameArray = [];
        let goodsIdArray = [];
        this.tableData.forEach((element) => {
          rowData.forEach((item) => {
            if (element.barCode === item.barCode && element.goodsName) {
              data.flag = true;
              goodsNameArray.push(element.goodsName);
              goodsIdArray.push(element.id);
            }
          });
        });
        data.goodsName = goodsNameArray;
        data.goodsId = goodsIdArray;
      } else {
        if (this.tableData.length > 0) {
          this.tableData.forEach((element) => {
            if (element.barCode === rowData.barCode && element.goodsName) {
              //console.log(element)
              data.flag = true;
              data.goodsName = element.goodsName;
            }
          });
        }
      }
      return data;
    },
    clearTableData() {
      this.tableData = [];
      this.initData();
    },
    getTableDataLength() {
      return this.tableData.length - 1;
    },
    getData() {
      let tableData = this.$utils.deepClone(this.tableData);
      tableData.splice(tableData.length - 1, 1);
      return tableData;
    },
    getSumData() {
      return this.tableData[this.tableData.length - 1];
    },
    getTabelData() {
      let tableData = this.$utils.deepClone(this.tableData);
      tableData.splice(tableData.length - 1, 1);
      tableData = tableData.filter((item) => {
        // 创建时间置空
        item.createDttm = null
        item.createBy = null
        item.lastModifyDttm = null
        item.lastModifyBy = null

        //将空字符串的数据从数据库删除
        if (item.barCode === "" && item.weBlitemGoodsMapId) {
          this.$axios.fetchDelete(api.warehouse.weBlitemGoodsMap + '?id=' + item.weBlitemGoodsMapId).then(data => {
          });
        }
        // 过滤没有条码的数据
        return (
          item[this.tableOptions.key || "barCode"] != "" &&
          item[this.tableOptions.key || "barCode"] != undefined &&
          item[this.tableOptions.key || "barCode"] != null
        );
      });
      return tableData;
    },
    // 获取表格数据
    getTableData(param) {
      if (!this.tableOptions.url) return;
      let searchParam = {
        pageNumber: this.page.current,
        pageSize: this.page.pageSize,
      };
      Object.assign(searchParam, this.tableOptions.param || {});
      Object.assign(searchParam, this.searchParam);
      Object.assign(searchParam, this.nowSearchParam);
      if (param) {
        Object.assign(searchParam, param);
      }
      this.loading = true;
      this.$axios
        .fetchPost(this.tableOptions.url + '/page', searchParam)
        .then((data) => {
          if (data.code == 200) {
            this.tableData = data.data.records;
            this.page.total = data.data.total;
            this.addMoreRow(this.tableData, 0);
            if (data.data.sumEntity) {
              this.sumEntity = data.data.sumEntity;
            }
          } else {
            this.$message({message: data.msg, type: "error"});
          }
        })
        .catch((err) => {
          console.log(err);
          this.$message({message: "请求失败！", type: "error"});
        }).finally(() => {
        this.loading = false;
      });
    },
  },
};
</script>
<style>
.list-operation .icon {
  font-size: 20px;
  color: #5e57e3;
  font-weight: bolder;
  line-height: 38px;
  display: inline-block;
  /*margin-top: 3px;*/
  cursor: pointer;
  /*margin-left: 10px;*/
}

.list-operation {
  padding-bottom: 20px;
}

.list-operation-table {
  overflow: auto;
  border: 1px solid #EBEEF5;
}

.list-operation-table div::-webkit-scrollbar {
  width: 8px;
  height: 10px;
  margin-top: 10px;
}

/*.el-table__body tr.current-row>td {*/
/*  background-color: red !important;*/
/*}*/
.list-operation .el-table__footer-wrapper tbody td,
.list-operation .el-table__header-wrapper tbody td {
  background-color: transparent;
}

.list-operation .el-table th.is-leaf {
  border-right: 0;
}

.list-operation .el-table th,
.list-operation .el-table tr {
  line-height: 33px;
}

.list-operation .el-input-number .el-input__inner {
  padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/template/listOperationPage.vue